const Icon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2H8C6.34315 2 5 3.34315 5 5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V5C19 3.34315 17.6569 2 16 2Z"
      stroke="#555"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M9 7H15" stroke="#555" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 11H15" stroke="#555" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 15H13" stroke="#555" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default Icon;
